export enum Statuses {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  DENIED = 'DENIED',
  MISSING = 'MISSING',
  MISSING_DOCS = 'MISSING_DOCS',
  PENDING = 'PENDING',
  WITHDRAWAL_AUTHORISATION_PENDING = 'WITHDRAWAL_AUTHORISATION_PENDING',
}
